<template>
  <div @click="goBack">
    <SvgIcon style="width: 42px;height: 42px;cursor: pointer;" type="trans" class="icon-24"></SvgIcon>
<!--    <p class="back">{{ backText }}</p>-->
  </div>
</template>
<script>
import SvgIcon from "@/components/SvgIcon.vue";
export default {
  props: {
    backText: {
      type: String,
      default: "mark_back",
    },
    definition: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // title(){
    //   return this.$t(this.backText)
    // }
  },
  components: {
    SvgIcon,
  },
  methods: {
    goBack() {
      if (this.backText === this.$t("mark_back") && !this.definition) {
        this.$router.go(-1);
      } else {
        this.$emit("goBackRoute");
      }
    },
  },
};
</script>
<style scoped>
.back {
  color: #474b64;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
